import React, { useContext, useState } from "react";
import Layout from "../components/Layout";
import { graphql } from "gatsby";
import "../components/main.scss";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { CartContext } from "../context/CartContext";
import Spinner from "react-bootstrap/Spinner";
import "bootstrap/dist/css/bootstrap.min.css";
import getStripe from "../utils/stripejs";
import Nav from "../components/Nav";
import { Helmet } from "react-helmet";
const CartPage = (props) => {
  const stripe = getStripe();
  const { addAmount, cart, subtractAmount, deleteItem, sum, cartAmount } =
    useContext(CartContext);
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (typeof window !== "undefined") {
      document.querySelector(".spinner-border").style.display = "block";
      document.querySelector("#check-out-button-text").style.display = "none";
    }
    setLoading(true);
    const cartProducts = [];
    cart.map((el) =>
      props.data.ProductStripe.edges.forEach((el2) =>
        el2.node.product.name === el.name
          ? cartProducts.push({
              price: el2.node.id,
              quantity: el.amount,
            })
          : false
      )
    );
    console.log(cartProducts);
    const stripe = await getStripe();
    const { error } = await stripe.redirectToCheckout({
      lineItems: [...cartProducts],
      mode: "payment",

      successUrl: `https://fruitkha.netlify.app/success/`,
      cancelUrl: `https://fruitkha.netlify.app/cart`,
    });
    if (error) {
      console.warn("Error:", error);
      setLoading(false);
    }
  };
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Cart</title>
        <meta
          name="description"
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        />
      </Helmet>
      <Layout>
        <Nav cart="cart-active-link" />
        <header class="header">
          <div className="black-overlay">
            <div class="container1" style={{ width: "100%", height: "100%" }}>
              <div className="header-text">
                <p className="header-p">FRESH AND ORGANIC</p>
                <h1 className="header-h1">Cart</h1>
              </div>
            </div>
          </div>
        </header>
        <section className="section-cart">
          <div className="container1">
            <div className="cart">
              {cartAmount !== 0 ? <h2>Total: {`${sum}$`}</h2> : false}

              {cart
                ? cart.map((el) => {
                    return (
                      <ul className="cart-list" id={el.name}>
                        <li>
                          <Link to={`/${el.name}`.toLowerCase()}>
                            <GatsbyImage
                              image={el.img}
                              alt={el.name}
                              width="128"
                            />
                          </Link>
                        </li>
                        <li>{el.name}</li>
                        <li>
                          <p>{`${el.price}$`}</p>
                        </li>
                        <li className="product-quantity">
                          <button
                            data-product={el.name}
                            onClick={(e) => {
                              e.preventDefault();
                              e.target.getAttribute("data-product");
                              const name =
                                e.target.getAttribute("data-product");

                              addAmount(name);
                            }}
                          >
                            <p>+</p>
                          </button>
                          <p>{el.amount}</p>
                          <button
                            data-product={el.name}
                            onClick={(e) => {
                              e.preventDefault();
                              const name =
                                e.target.getAttribute("data-product");
                              subtractAmount(name);
                            }}
                          >
                            <p>-</p>
                          </button>
                        </li>
                        <li>
                          <p>{`${el.amount * el.price}$`}</p>
                        </li>
                        <li>
                          <button
                            data-product={el.name}
                            onClick={async (e) => {
                              e.preventDefault();
                              const name =
                                e.target.getAttribute("data-product");
                              await deleteItem(name);
                              console.log(cart);
                            }}
                          >
                            delete
                          </button>
                        </li>
                      </ul>
                    );
                  })
                : false}

              <div className="total-container">
                {cartAmount !== 0 ? (
                  <button onClick={handleSubmit} className="check-out">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <span id="check-out-button-text">Check out</span>
                  </button>
                ) : (
                  false
                )}
              </div>
              <h2 className="cart-empty">
                {cartAmount === 0 ? "Cart is empty" : false}
              </h2>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default CartPage;
export const query = graphql`
  query CartPageQuery {
    ProductStripe: allStripePrice(
      filter: { active: { eq: true } }
      sort: { fields: [unit_amount] }
    ) {
      edges {
        node {
          id
          active
          currency
          unit_amount
          product {
            id
            name
            images
          }
        }
      }
    }
  }
`;
